import paari from '../Assests/Testimonials/paari.png'
import Vishwa from '../Assests/Testimonials/Vishwa.png'
import bhargav from '../Assests/Testimonials/bhargav.png'




export const testimonialPageData = [
    {
        img: paari,
        name: "Paari Kannappan",
        designation:"Director of RentV",
        description:"TechClockers exceeded all our expectations! Their team's technical expertise and dedication to delivering results were outstanding." 
    },
    {
        img: bhargav,
        name: "Bhargav Varma",
        designation:"Director of Cornars",
        description:"Working with TechClockers has been an absolute pleasure. Their team's innovative approach and attention to detail made the entire process seamless." 
    },
    // {
    //     img: Vishwa,
    //     name: "Vishwanath Reddy",
    //     designation:"Product Designer",
    //     description:"Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit o" 
    // },
]